import { gsap } from 'gsap'


// =============================================================================
// Menu Toggle
// =============================================================================
export function menuToggle() {
	let menuTogg = document.querySelector('#menu-toggle');
	let menuIcon = document.querySelector('.menu-icon');

  // Detect Scroll
  function menuScrollStyle() {
    let scrolled = document.scrollingElement.scrollTop;
    let position = document.querySelector('body').offsetTop;
    if( scrolled > position + 10 ) {
      menuTogg.classList.add('scrolled');
      menuIcon.classList.add('menu-icon--blue')
    } else {
      menuTogg.classList.remove('scrolled');
      menuIcon.classList.remove('menu-icon--blue')
    } 
  }

  menuScrollStyle()
  window.addEventListener('scroll', menuScrollStyle)

	document.querySelector('#menu-toggle').addEventListener('click', checkNav);
	window.addEventListener("keyup", function(e) {
		if (e.key == 'Escape') closeNav();
	}, false);

	function checkNav() {
		if (document.body.classList.contains('menu-toggle-active')) {
			closeNav();
		} else {
			openNav();
		}
	}

  // Animation setup
  let mm = gsap.matchMedia();

  const menuItems = gsap.utils.toArray('#nav-primary li.menu-item');
  menuItems.push(document.querySelector('#nav-primary .cta .button'));

  mm.add("(max-width: 1024px)", () => {
    gsap.set(menuItems, {autoAlpha: 0, y: 20})
  })

	function openNav() {
		// Body
		document.body.classList.add('menu-toggle-active');

    mm.add("(max-width: 1024px)", () => {
      gsap.to(menuItems, {duration: 0.75, delay: 0.25, autoAlpha: 1, y: 0, stagger: 0.1})
    });


		// Toggle
		menuTogg.classList.add('collapsed');
		setTimeout(() => {
			menuTogg.classList.add('plus');
		}, 100);
		setTimeout(() => {
			menuTogg.classList.add('spin');
		}, 100);
	}

	function closeNav() {
    console.log('closing nav');

		// Body
		document.body.classList.remove('menu-toggle-active');

    mm.add("(max-width: 1024px)", () => {
      gsap.to(menuItems, {duration: 0.75, autoAlpha: 0, y: 20})
    });

		// Toggle
		menuTogg.classList.remove('spin',);
		setTimeout(() => {
			menuTogg.classList.remove('plus');
		}, 100);
		setTimeout(() => {
			menuTogg.classList.remove('collapsed');
		}, 300);
	}

	// Hash links on the same page should close the menu
	let navLinks = document.querySelectorAll('#nav-primary a');

	for (const navLink of navLinks) {
		navLink.addEventListener('click', (function(e) {
			closeNav();
		}));
	}

  window.addEventListener('resize', () => {
    if(window.matchMedia("(min-width: 1023.98px)").matches) {
      gsap.set(menuItems, {autoAlpha: 1, y: 0})
    }
  })

}

// =============================================================================
// Menu Hovers
// =============================================================================

export function menuHovers() {
  const menuItems = document.querySelectorAll('nav#nav-primary li.menu-item')

  for (const menuItem of menuItems) {   
    
    function measureWidth() {
      const menuLink = menuItem.querySelector('a')
      let menuItemWidth = menuItem.clientWidth

      menuLink.style.width = `${menuItemWidth}px`
    }
    
    measureWidth()
    window.addEventListener('resize', measureWidth)
      
    menuItem.classList.add('hover-font-change')
  } 

}